import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { AffiliateProgram as AffiliateProgramContent } from 'AffiliateProgram';
import { CreatorProgram as CreatorsProgramContent } from 'CreatorsProgram';

const AffiliateProgram = () => {
  const {
    flags: { useNewCreatorsPage },
  } = useFeatureFlags();
  return (
    <AppLayout>
      {useNewCreatorsPage ? (
        <CreatorsProgramContent />
      ) : (
        <AffiliateProgramContent />
      )}
    </AppLayout>
  );
};

export default AffiliateProgram;
